import {
    LOGIN_ACTION,
    LOGOUT_ACTION,
    REFRESH_TOKEN_ACTION,
    VALIDATE_LOGIN_ACTION,
    SAVE_USER_INFO_ACTION,
} from '../action-types/auth';
import { isFalsy } from '../../public/utils/common';
import initialState from '../initial-state/auth';
import update from '../../public/utils/immutable-update';

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_ACTION: {
            const { userId, username, token, authenticated } = action;
            const settings = {
                authenticated: { $set: authenticated },
                userId: { $set: userId },
                token: { $set: token },
            };
            if (username) {
                settings.userInfo = { $auto: {
                    username: {
                        $set: username,
                    },
                } };
            }
            return update(state, settings);
        }
        case SAVE_USER_INFO_ACTION: {
            const { userInfo } = action;
            const settings = {
                userInfo: { $auto: {
                    $merge: userInfo,
                } },
            };
            return update(state, settings);
        }
        case VALIDATE_LOGIN_ACTION: {
            const { userId, token } = state;
            if (isFalsy(userId) || isFalsy(token)) {
                return state;
            }
            const settings = {
                authenticated: { $set: true },
            };
            return update(state, settings);
        }
        case LOGOUT_ACTION: {
            document.cookie = '';
            return initialState;
        }
        case REFRESH_TOKEN_ACTION: {
            const { token } = action;
            const settings = {
                token: { $set: token },
            };
            return update(state, settings);
        }
        default:
            return state;
    }
};

export default authReducer;



// WEBPACK FOOTER //
// ./src/common/reducers/auth.js